import { render, staticRenderFns } from "./PageDivider.vue?vue&type=template&id=3bdd4100&scoped=true"
import script from "./PageDivider.vue?vue&type=script&lang=js"
export * from "./PageDivider.vue?vue&type=script&lang=js"
import style0 from "./PageDivider.vue?vue&type=style&index=0&id=3bdd4100&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdd4100",
  null
  
)

export default component.exports